/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { authTeamsList } from "../../funcs/authTeamsList.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.ListTeamsRequest$inboundSchema,
};

export const tool$authTeamsList: ToolDefinition<typeof args> = {
  name: "auth-teams-list",
  description: `List teams in an org`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await authTeamsList(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
